const PICTURE_TYPES = [
  { key: 'general', text: 'General', value: 'general' },
  { key: 'site_plan', text: 'Site Plan', value: 'site_plan' },
  { key: 'unit_layout', text: 'Unit Layout', value: 'unit_layout' },
  { key: 'map', text: 'Map', value: 'map' },
];
export default PICTURE_TYPES;



// WEBPACK FOOTER //
// ./src/constants/pictureTypes.js